import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import { Layout, NewsLetterBar, SharedHero } from '../../v2/components/common';
import {
  CaseStudy,
  Customers,
  ExploreMore,
  Info,
  TransformBusiness,
} from '../../v2/components/pros-restoration';
import { URLS } from '../../v2/constants';

const ProsRestoration: React.FC = () => (
  <Layout title="Pros restoration" buttonType="CHAT_WITH_A_REP">
    <SharedHero
      heading="Through the storm and beyond."
      body="Shaping the workflow for the modern restoration professional."
      chatWithUsLink={URLS.restoration.chatWithUs}
      desktopImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/pros_restoration_hero_desktop.png"
          alt="pros restoration hero"
          objectFit="cover"
        />
      }
      mobileAndTabletImage={
        <StaticImage
          loading="eager"
          placeholder="blurred"
          src="../../v2/assets/images/pros_restoration_hero_tablet.png"
          alt="pros restoration hero"
          objectFit="contain"
        />
      }
    />
    <Info />
    <CaseStudy />
    <Customers />
    <TransformBusiness />
    <ExploreMore />
    <NewsLetterBar showForm showViewJobs={false} />
  </Layout>
);

export default ProsRestoration;
